import React, { useRef, useState, useEffect } from "react";
import { Circle, GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import "./movableMap.css"
import { connect } from "react-redux";
import { hideLoader , showLoader } from './../../../actions/UserActions';
import { addIntraCityPickupDropLocation, removeIntraCityPickupDropLocation, setIntraCityPickupDropLocation, addIntraCityPickupPackages, 
  removeIntraCityPickupDropPackages, setIntraCityPackages, createCustomerBookingRequest, getIntraCityPrice, setIntraCity , actualgetIntraCityPrice } from "../../../actions/customerBooking";
import showMessage, { failed } from "../../../utils/message";


function TravellingMarker({position}:any) {

  return (
    <div>
      {position ? 
        <Marker
          position={position}
        />
        :
        <Marker
          position={
            {
              lat: 23.068586,
              lng: 72.653595  
            }
          }
          />
      }
    </div>

  );
}

function MovableMap(props:any) {
  const mapRef:any = useRef(null);
  const [map, setMap] = useState<any>(null);
  const [mapCenter, setMapCenter] = useState<any>({lat  : '23.0225',lng : '72.5714'});
  const [currentLatLng , setCurrentLatLng] = useState<any>({lat  : "",lng : ""})
  const [mapMoving , setMapMoving] = useState(false);
  const [locatedAddress , setLocatedAddress] = useState(``)
  // const [currentCoordinates, setCurrentCoordinates] = useState<any>();

  const handleMapLoad = (mapInstance:any) => {
    setMap(mapInstance);
  };

  const debounce = (func:any, delay:any) => {
    let timeoutId:any;
    return (...args:any) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const handleMapCenterChanged = debounce(() => {
    if (map) {
      const newCenter = {
        lat: map.getCenter().lat(),
        lng: map.getCenter().lng()
      };
      setMapCenter(newCenter);
      console.log("zdhxvjbjvf",newCenter);
    }
  }, 200);

  // const handleMapCenterChanged = (value:any) => {
  //   // console.log('value',value);
  //   // if(value === "Start"){
  //   //   setMapMoving(true)
  //   // }
  //   // if(value === "End"){
  //   //   setMapMoving(false)
  //   // }
  //   if (map) {
  //     const newCenter = {
  //       lat: map.getCenter().lat(),
  //       lng: map.getCenter().lng()
  //     };
  //     setMapCenter(newCenter);
  //     console.log("zdhxvjbjvf",newCenter);
  //   }
  // }

  let {latLongData,mobileViewState,customerMode,driverMode} = props;
  
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyA5kw1jdPoWOGfUDL0o2vW0Ezf2Cvq12OU"
  });
  
  const handleMapDrag = async () => {
    const geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(mapCenter?.lat, mapCenter?.lng);
  
    await geocoder.geocode({ location: latLng }, (results : any, status : any) => {
      console.log('mapCenter Final Dragged to:', results);
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          const tewmpCenters = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          };
          setMapCenter(tewmpCenters)
          console.log("mapCenter Final Dragged to 2030",results[0].geometry.location.lat())
          console.log("mapCenter Final Dragged to 2030",results[0].geometry.location.lng())
          const address = results[0].formatted_address;
          console.log('mapCenter Final Dragged to:', address);
          // Handle the retrieved address here
          setLocatedAddress(address)
        }
      }
    });
  };  

  useEffect(()=>{
    if(latLongData.latFrom !== null || latLongData.lngFrom !== null){
      const newCenter = {
        lat: latLongData.latFrom,
        lng: latLongData.lngFrom
      };
      setMapCenter(newCenter);
      setCurrentLatLng(newCenter)
    }
    else if(latLongData.latFrom === undefined || latLongData.lngFrom === undefined){
      const newCenter = {
        lat: `23.0225`,
        lng: `72.5714`
      };
      setMapCenter(newCenter);
    }
    console.log("latLongData.latFrom",latLongData)
  },[latLongData])

  const Options = {
    // minZoom: 15,
    // maxZoom: 15,
    fullscreenControl: false,
    styles: [
      // Customize map styles
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
    ],
    mapTypeControl: false, // Hide map type control
    gestureHandling: 'cooperative', // Disable map gestures
    // draggable: false,
    // draggable: false, // Disable map dragging
    // fullscreenControl: false, // Hide fullscreen control
    // zoomControl: false, // Hide zoom control
    // mapTypeControl: false, // Hide map type control
    // streetViewControl: false, // Hide street view control
    // rotateControl: false, // Hide rotate control
    // scaleControl: false, // Hide scale control
    // scrollwheel: false, // Disable scrollwheel zoom
  }

  const image = {
    url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png' // URL for the blue marker icon
    // url: "https://i.ibb.co/HF6XY5h/icons8-location-pin-32.png",
  };

  const handleValuesFromMap = () => {
    let TempLatLng = mapCenter;
    if(locatedAddress && locatedAddress.length > 0){
      props.setIntraCityPickupDropLocation('place.placeValue', locatedAddress, props?.indexForRedux)
      setMapCenter(TempLatLng)
      console.log(`mapCenter mapCenter 2`,mapCenter)
    }
    else{
      showMessage(`Kindly Select Lcoation on Map Correctly.`,failed , 2000)
    }
  }

  console.log(`mapCenter locatedAddress`,props?.indexForRedux,mapCenter)

  return (
    <div id="MovableMap">
      {loadError && <p>{loadError}</p>}
      {!isLoaded && <p>Loading .. </p>}
      {isLoaded && (
        <div style={{display:"flex",justifyContent:"center"}}>
          {mobileViewState ? 
            <GoogleMap
              mapContainerStyle={{ 
                  margin: customerMode ? "0px" : driverMode ? "0px" : "3%",
                  width: customerMode ? "100%" : driverMode ? "100%" : "70%", 
                  height: customerMode ? "350px" : driverMode ? "200px" : "450px" 
              }}
              id={"map"}
              ref={mapRef}
              center={mapCenter} 
              onDragStart={() => {handleMapCenterChanged(),setMapMoving(true)}}
              onDragEnd={() => {handleMapCenterChanged(),setMapMoving(false),handleMapDrag()}}
              zoom={13}
              onLoad={handleMapLoad}
              options={Options}
            >
              {/* <TravellingMarker
                position={ mapCenter }
              /> */}
              
              <Marker
                icon= {{
                  path: google.maps.SymbolPath.CIRCLE,
                  fillColor: '#448aff',
                  fillOpacity: 1,
                  strokeColor: 'white',
                  strokeWeight: 1,
                  scale: 5 // Adjust the dot size as desired
                }}
                position={
                  {
                    lat: currentLatLng.lat,
                    lng: currentLatLng.lng  
                  }
                }
              />
              {mapMoving ?
                <img
                  src="https://i.ibb.co/NVqkwpC/download-removebg-preview-1.png"
                  style={{ position: 'relative', top: '44%', left: '50%', transform: 'translate(-50%, -50%)' , height:"35px" }}
                />
                :
                <img
                  src="https://i.ibb.co/qNYSsGY/download-removebg-preview.png"
                  style={{ position: 'relative', top: '45%', left: '50%', transform: 'translate(-50%, -50%)' , height:"35px"}}
                />
              }
              {mapMoving &&
                <img
                  src="https://i.ibb.co/XZHwhh4/icons8-dot-24.png"
                  style={{ position: 'relative', top: '45.5%', left: '40.75%', transform: 'translate(-50%, -50%)' , height:"5px" , borderRadius : "50%" , backgroundColor : "#1a85fc" }}
                />
              }
              
              {!mapMoving && locatedAddress.length > 0 && 
                <div className="mapSuggetions" onClick={() => handleValuesFromMap()}>
                  {locatedAddress}
                </div>
              }
            </GoogleMap>
            :
            <GoogleMap
              id={"map"}
              mapContainerStyle={{
                marginLeft: customerMode ? "0px" : driverMode ? "0px" : "20px",
                width: customerMode ? "300px" : driverMode ? "280px" : "1500px",
                height: customerMode ? "200px" : driverMode ? "200px" : "600px",
              }}
              ref={mapRef}
              center={mapCenter} 
              onDragStart={() => {handleMapCenterChanged(),setMapMoving(true)}}
              onDragEnd={() => {handleMapCenterChanged(),setMapMoving(false),handleMapDrag()}}
              zoom={13}
              onLoad={handleMapLoad}
              options={Options}
            >
              {/* <TravellingMarker
                position={ mapCenter }
              /> */}
              
              <Marker
                icon= {{
                  path: google.maps.SymbolPath.CIRCLE,
                  fillColor: '#448aff',
                  fillOpacity: 1,
                  strokeColor: 'white',
                  strokeWeight: 1,
                  scale: 5 // Adjust the dot size as desired
                }}
                position={
                  {
                    lat: currentLatLng.lat,
                    lng: currentLatLng.lng  
                  }
                }
              />
              {/* <Circle
                center={{
                  lat: currentLatLng.lat,
                  lng: currentLatLng.lng  
                }}
                radius={100}
                options={{
                  strokeColor: "#448aff",
                  strokeOpacity: 0.8,
                  strokeWeight: 0.5,
                  fillColor: "#448aff",
                  fillOpacity: 0.35,
                }}
              /> */}
              {mapMoving ?
                <img
                  src="https://i.ibb.co/NVqkwpC/download-removebg-preview-1.png"
                  style={{ position: 'relative', top: '38%', left: '50%', transform: 'translate(-50%, -50%)' , height:"35px" }}
                />
                :
                <img
                  src="https://i.ibb.co/qNYSsGY/download-removebg-preview.png"
                  style={{ position: 'relative', top: '40%', left: '50%', transform: 'translate(-50%, -50%)' , height:"35px"}}
                />
              }
              {mapMoving &&
                <img
                  src="https://i.ibb.co/XZHwhh4/icons8-dot-24.png"
                  style={{ position: 'relative', top: '40%', left: '38%', transform: 'translate(-50%, -50%)' , height:"5px" , borderRadius : "50%" , backgroundColor : "#1a85fc" }}
                />
              }
              {locatedAddress.length > 0 && 
                <div className="mapSuggetions" onClick={() => handleValuesFromMap()}>
                  {locatedAddress}
                </div>
              }
            </GoogleMap>
          }
        </div>
      )}
    </div>
  );
}


const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    customerReducer: state.customerLoginReducer,
    customerBooking: state.customerBooking,
    booking : state.booking
  };
};

const mapDispatchToProps = {
  addIntraCityPickupDropLocation,
  removeIntraCityPickupDropLocation,
  setIntraCityPickupDropLocation,
  addIntraCityPickupPackages,
  removeIntraCityPickupDropPackages,
  setIntraCityPackages,
  createCustomerBookingRequest,
  actualgetIntraCityPrice,
  getIntraCityPrice,
  setIntraCity,
  showLoader,
  hideLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(MovableMap);